export default {
    list: {
        title: 'Team',
        subtitle: 'Gestisci i membri del tuo team',
        invite: 'Invita Membro',
        loading: 'Caricamento team...',
        addMember: 'Aggiungi Membro',
        allRoles: 'Tutti i ruoli',
        allStatuses: 'Tutti gli stati',
        searchPlaceholder: 'Cerca per nome o email...',
        rolePlaceholder: 'Filtra per ruolo',
        statusPlaceholder: 'Filtra per stato',
        description: 'Lista dei membri del tuo team',
        headers: {
            name: 'Nome',
            email: 'Email',
            role: 'Ruolo',
            status: 'Status',
            lastLogin: 'Last Login',
            inviteDate: 'Data Invito',
            actions: 'Azioni',
        },
        noMembers: {
            title: 'Nessun membro del team trovato',
            message: 'Prova a modificare i filtri di ricerca',
            emptyMessage: 'Inizia aggiungendo il tuo primo membro del team',
            addFirst: 'Aggiungi Primo Membro',
        },
        modal: {
            addTitle: 'Aggiungi Membro',
            editTitle: 'Modifica Membro',
            fields: {
                name: 'Nome',
                namePlaceholder: 'Inserisci nome',
                email: 'Email',
                emailPlaceholder: 'nome@azienda.com',
                role: 'Ruolo',
                rolePlaceholder: 'Seleziona il ruolo',
                status: 'Status',
                statusPlaceholder: 'Seleziona lo status',
            },
            cancel: 'Annulla',
            save: 'Salva',
            create: 'Crea',
        },
        statusLabels: {
            active: 'Attivo',
            inactive: 'Inattivo',
        },
        never: 'Mai',
        confirmDelete: 'Sei sicuro di voler eliminare questo membro del team?',
    },
};
